import * as React from "react";
import Notification from "../../notification/notification";
import InputMask from "react-input-mask";
import TextField from "@material-ui/core/TextField";
import { AddressClass } from "../../../../helpers/address";
import { observer } from "mobx-react";
import { ValidatedValue } from "../../../../helpers/validator";
import classNames from "classnames";

interface ZipCodeFieldProps {
  onChange?: (event: any) => void;
  onBlur?: (event: any) => void;
  value: ValidatedValue<string>;
  id?: string;
  disabled?: boolean;
  displayLabel?: boolean;
}

@observer
export default class ZipCodeField extends React.Component<ZipCodeFieldProps> {

  private beforeMaskedValueChange = (newState: any, oldState: any, userInput: any) => {
    let { value } = newState;
    let selection = newState.selection;
    let cursorPosition = selection ? selection.start : null;

    if (!!userInput && userInput.length < value.length && !(value.length > this.props.value.value.length)) {
      cursorPosition = cursorPosition - 2;
      selection = { start: cursorPosition, end: cursorPosition };
      value = value.slice(0, -2);
    }

    return {
      value,
      selection
    };
  }

  public render() {
    const errorMessage = !!this.props.value.errorMessage;
    return (
      <div className="field-container zip-code">
        {this.props.displayLabel && <div className="label">{AddressClass.displayName.zipCode}</div>}
        <InputMask
          id={this.props.id}
          mask="99-999"
          value={this.props.value.value}

          disabled={this.props.disabled}
          maskChar=""
          onChange={(event) => {
            this.props.value.setValue(event.target.value);
            if (this.props.onChange) {
              this.props.onChange(event);
            }
          }}
          beforeMaskedValueChange={this.beforeMaskedValueChange}
          onBlur={(event) => {
            this.validate();
            if (this.props.value.errorMessage === "") {
              this.onBlur(event);
            }
          }}
        >
          {() => <TextField
            variant="outlined"
            size="small"
            error={errorMessage}
            helperText={this.getHelperText()}
            onKeyDown={() => {
              this.props.value.clearValidation();
            }}
            label={AddressClass.displayName.zipCode}
            InputLabelProps={{
              shrink: true
            }}
            placeholder="XX-XXX"
            className={classNames("zip-code text-input MuiFormControl-marginNormal", { "disabled": this.props.disabled })}
            disabled={this.props.disabled}
          />}
        </InputMask>
      </div>
    );
  }

  private getHelperText() {
    return !!this.props.value.errorMessage
      ? <Notification type="error" message={this.props.value.errorMessage} />
      : "";
  }

  public validate() {
    this.props.value.validate();
  }

  private onBlur(event: any) {
    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
  }
}
